<template>
    <CardCarousel
        :items="items"
        :dummy="isDummy"
        :title="props.title"
        :link="props.link"
        :lastItemLink="props.lastItemLink"
        :rows="props.rows ?? 2"
        withBadges
    >
        <template #default="{ index, item: game, className }">
            <GameCard
                :game="game"
                :appearance="props.firstItemTabletPlusBig && index === 0 ? 'big_horizontal' : 'medium_horizontal'"
                :targetLink="props.targetLinkGame"
                :data-interface-target="`game-number-${index + 1}`"
                responsive
                :class="className"
                lazy
                withBadges
            />
        </template>
    </CardCarousel>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import CardCarousel from '@/components/CardCarousel.vue'
import GameCard from '@/components/GameCard/GameCard.vue'
import type { LinkTarget, MainCategoriesType, ShortGameType } from '@/types'

interface GameCarouselProps {
    title?: string
    categoryId?: MainCategoriesType
    link?: RouteLocationRaw
    games?: ShortGameType[]
    firstItemTabletPlusBig?: boolean
    lastItemLink?: RouteLocationRaw
    targetLinkGame?: LinkTarget
    rows?: number
}

const props = defineProps<GameCarouselProps>()

const items = computed(() => props.games || Array<undefined>(20).fill(undefined))
const isDummy = computed(() => !props.games)
</script>
